export default __webpack_public_path__ + "static/media/48.558710a2.png";